import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import '../WallofFame/../header/style.css';
import { Header } from "../WallofFame";
import { AdminNavbar } from "../WallofFame";
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url } from '../../../constants/apiConstants';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function EditWallofFame() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState("");
    const [lobo, setLobo] = useState(null);
    const [existingImage, setExistingImage] = useState("");

    useEffect(() => {
        fetchAnnouncementData();
    }, [id]);

    const fetchAnnouncementData = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getWallOfFameById/${id}`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });
            if (response.data.length > 0) {
                const data = response.data[0];
                setTitle(data.wall_fame || "");
                setDescription(data.wall_fame_description || "");
                setStatus(data.status || "");
                setExistingImage(data.media_image_name || "");
            }
        } catch (err) {
            console.error("Error fetching announcement data:", err);
        }
    };

    const handleFileChange = (e) => {
        setLobo(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("wall_fame", title);
        formData.append("wall_fame_description", description);
        formData.append("status", status);
        if (lobo) {
            formData.append("media_image_name", lobo);
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/createWallOfFame/${id}`, formData, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200) {
                navigate("/admin/wallofFameList");
            } else {
                console.error("Unexpected response:", response.status);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Edit WallofFame</h1>
                        </div>
                        <div className="report-body">
                            <div className="user-form">
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <ReactQuill
                                            theme="snow"
                                            value={description}
                                            onChange={setDescription}
                                            style={{ height: '200px', marginBottom: '50px' }}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Lobo (Upload Image)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                        {existingImage && (
                                            <div className="mt-2">
                                                <strong>Current Image:</strong><br />
                                                <img
                                                    src={`${Image_Base_Url}/${existingImage}`}
                                                    alt="Current"
                                                    style={{ height: '100px', borderRadius: '8px', marginTop: '10px' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    <button type="submit" className="btn btn-primary submit-btn">
                                        UPDATE
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditWallofFame;
